exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2GWeN__lBw8HYh{padding:0 2px;background-color:rgba(9,30,66,.04);border-radius:3px;display:flex;flex-direction:row;align-items:center;justify-content:center;font-size:12px;width:100%;height:100%}._2GWeN__lBw8HYh:not(._3M1O6cMw1XQ7ja) ._3yw4EH7YVfmNMm{margin-right:4px}._2GWeN__lBw8HYh._3LL9SXbglIxF7F{color:#fff;background-color:#61bd4f}._2GWeN__lBw8HYh._1xHX_iRJDlahmR{color:#fff;background-color:#f2d600}._2GWeN__lBw8HYh._2FXyaO_ffHYKGA{color:#fff;background-color:#eb5a46}._2GWeN__lBw8HYh._33SVsPPrKUKvPx{color:#fff;background-color:#ec9488}", ""]);

// exports
exports.locals = {
	"badge": "_2GWeN__lBw8HYh",
	"unset": "_3M1O6cMw1XQ7ja",
	"icon": "_3yw4EH7YVfmNMm",
	"is-due-complete": "_3LL9SXbglIxF7F",
	"is-due-soon": "_1xHX_iRJDlahmR",
	"is-due-now": "_2FXyaO_ffHYKGA",
	"is-due-past": "_33SVsPPrKUKvPx"
};